'use client';

import { useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import Typography from '@alltrails/core/components/Typography';
import Button from '@alltrails/denali/components/Button';
import Heading from '@alltrails/denali/components/Heading';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import aboutHeroMobile from '../../assets/images/about-footer-hero-750w.avif';
import aboutHero from '../../assets/images/about-footer-hero.avif';
import styles from './styles/CrossPaths.module.scss';

const CrossPaths = () => {
  const intl = useIntl();
  const JOIN_OUR_TEAM = intl.formatMessage({ defaultMessage: 'Join our team' });
  const GET_PRESS_DETAILS = intl.formatMessage({ defaultMessage: 'Get press details' });
  const isMobile = useIsMobileSizedScreen();

  return (
    <div className={styles.container}>
      <Image
        src={isMobile ? aboutHeroMobile : aboutHero}
        className={styles.heroImage}
        alt={intl.formatMessage({ defaultMessage: 'Runner running in the distance' })}
        fill
      />
      <div className={styles.contentContainer}>
        <Heading as="h2" className={styles.headingText} size="500">
          {intl.formatMessage({ defaultMessage: "Let's cross paths" })}
        </Heading>
        <Typography component="div" mb="24" variant="text300">
          {intl.formatMessage({
            defaultMessage:
              'Ready to take the next step in your career journey? Want to partner up for a story? We look forward to connecting with you.'
          })}
        </Typography>
        <div className={styles.ctaContainer}>
          <Button text={JOIN_OUR_TEAM} linkInfo={{ href: '/careers' }} className={styles.ctaButton} aria-label={JOIN_OUR_TEAM} variant="primary" />
          <Button
            text={GET_PRESS_DETAILS}
            linkInfo={{ href: '/press' }}
            className={styles.ctaButton}
            aria-label={GET_PRESS_DETAILS}
            variant="ghost"
            elevated
          />
        </div>
      </div>
    </div>
  );
};

export default CrossPaths;
